import Marquee from "react-fast-marquee";
import { useLang } from "../i18n";

export default function EditorialMarquee() {
  const { t } = useLang();
  return (
    <div data-testid="editorial-marquee" className="border-y border-black/10 bg-linen2 py-5 overflow-hidden">
      <Marquee speed={28} gradient={false}>
        {Array.from({ length: 4 }).map((_, i) => (
          <span key={i} className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-black/60 mx-8 whitespace-nowrap">
            {t.marquee} <span className="text-terra mx-8">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
